import { Component, OnInit, OnDestroy, Input, Output, EventEmitter} from '@angular/core';
import { Subscription } from 'rxjs';
import { GridModel } from './edit-grid-model';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { EditGridService } from './edit-grid.service';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import { KeepHtmlPipe } from 'app/modules/shared/pipes/keep-html.pipe';
import { KeyValueModel } from 'app/modules/shared/models/key-value';
import { LazyLoadEvent } from 'primeng/api';


@Component({
  selector: 'app-edit-mi-grid',
  providers: [EditGridService, KeepHtmlPipe],
  templateUrl: './edit-mi-grid.component.html',
  standalone: false
})

export class EditMiGridComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  rowData: any[] = [];
  search = '';
  @Output() rowClickedEvent = new EventEmitter<any>();
  @Output() actionBtnClickedEvent = new EventEmitter<any>();
  @Output() onFocusEvent = new EventEmitter<any>();
  @Output() getGridReference: EventEmitter<any> = new EventEmitter();
  @Input() url: any = '';
  @Input() bottomSearchBar: Boolean;
  @Input() isDetailScreen: Boolean;
  @Input() bottomExportButton: Boolean;
  @Input() rowSelection = 'single';
  @Input() printUrl: any = '';
  @Input() exportUrl: any = '';
  @Input() columnDefs: any[] = [];
  @Input() actionButtonsDefs: any[] = [];
  @Input() pagination: any = true;
  @Input() paginationPageSize: any = 15;
  @Input() paginationStartPage: any = 0;
  @Input() defaultSortField = '';
  @Input() divClass = '';
  @Input() actionButtonWidth = 150;
  @Input() inputPlaceholder = '';
  gridUrlParams = '';
  enableResizer = 'false';
  displayRowView = false;
  rowSelectIndex = 0;
  @Input() overlayLoadingTemplate: any = '<span class="ag-overlay-loading-center" "style=background:red">' +
    'Please wait while your rows are loading</span>';
  datasource = [];
  model: GridModel;
  totalRecords = 0;
  sortF = '';
  first: any = 0;
  sortO = '';
  offset = 0;
  setRowLength = 15;
  searchText = '';
  selectedRecords: any = [];
  suggestion: KeyValueModel[] = [{ key: '1', value: '1' }]

  constructor(
    private uiService: UiService,
    private gridService: EditGridService,
    private liveAnnouncer: LiveAnnouncer,
    private commonBindingDataService: CommonBindingDataService) { }

  ngOnInit() {
    this.subscription = this.uiService.sidebarToggledEvent
      .subscribe((state: string) => {
        this.refreshList();
      });
  }

  refreshList() {
    this.fetchAndLoadData();
  }

  fetchAndLoadData() {
    const that = this;
    if (that.url) {
      this.gridService.loadGridData(that.getUrl(that.url)).subscribe(result => {
        this.rowSelectIndex = 0;
        const model = <GridModel>result;
        if (result !== undefined) {
          this.totalRecords = model.count;
          that.datasource = [];
          const data = model.data === null ? [] : model.data
          data.forEach(e => {

            that.columnDefs.forEach(c => {
              e[c.suggestion] = c.suggestion;
              e[c.placeholder] = c.placeholder;
              if (c.inputType === 'multiAutoComplete') {
                e[c.keyId] = this.getKeyValue(c.keyId, e);
              }
              if (c.suggestion !== undefined) {
                if (c.inputType === 'multiAutoComplete') {
                  e[c.model] = this.getMultiModel(c.suggestion, c.keyId, e);
                } else {
                  e[c.model] = this.getModel(c.suggestion, c.keyId, e);
                }
              }
              if (c && c.cellRenderer) {
                e[c.field] = c.cellRenderer(e);
              } else if (c && c.cellRendererHtml) {
                e[c.field] = c.cellRendererHtml(e);
              }
              that.actionButtonsDefs.forEach(d => {
                if (d.show) {
                  e[d.field] = d.show(e);
                }
                if (d.title) {
                  e[d.title] = d.title(e);
                }
                if (d.ariaLabel) {
                  e[d.ariaLabel] = d.ariaLabel(e);
                }
              });
            });
            that.datasource.push(e);
          });

          const paginatorFirst = document.getElementsByClassName('p-paginator-first');
          paginatorFirst[0].setAttribute('aria-label', this.commonBindingDataService.getLabel('aria_label_paginator_go_to_first'));

          const paginatorPrevious = document.getElementsByClassName('p-paginator-prev');
          paginatorPrevious[0].setAttribute('aria-label', this.commonBindingDataService.getLabel('aria_label_paginator_go_to_previous'));

          const paginatorNext = document.getElementsByClassName('p-paginator-next');
          paginatorNext[0].setAttribute('aria-label', this.commonBindingDataService.getLabel('aria_label_paginator_go_to_next'));

          const paginatorLast = document.getElementsByClassName('p-paginator-last');
          paginatorLast[0].setAttribute('aria-label', this.commonBindingDataService.getLabel('aria_label_paginator_go_to_last'));

          const paginatorPageLinks = document.getElementsByClassName('p-paginator-page');
          for (let index = 0; index < paginatorPageLinks.length; index++) {
            paginatorPageLinks[index].setAttribute('aria-label', 'Page ' + paginatorPageLinks[index].textContent);
          }

        }
      });
    }
  }

  getKeyValue(key, e) {
    return e[key] !== null && e[key] !== ''  ? e[key].split(',') : [];
  }

  getModel(suggestion, key, data) {
    const s = suggestion.filter(elements => { return elements.value === data[key] });
    return s[0];
  }

  getMultiModel(suggestion, key, data) {
    const returnValue = [];
    data[key].forEach(element => {
      returnValue.push(suggestion.filter(elements => { return elements.value === element })[0]);
    });
    return returnValue;
  }

  onSelect(event, key, rowData, model, autoComplete) {
    rowData[key] = event.value.value
    rowData[model] = event.value;
    autoComplete.hide();
  }

  checkType(value) {
    return typeof value === 'object';
  }

  getUrl(url) {
    const that = this;
    let params = 'searchText=' + this.searchText + '&offset=' + this.offset + '&limit=' + this.setRowLength;
    params += '&sortColumn=';
    params += this.sortF;
    params += '&sortType=';
    params += this.sortO;
    let buildUrl = url;
    if (url.lastIndexOf('?') < 0) {
      buildUrl += '?';
    } else {
      buildUrl += '&';
    }
    if (this.url.lastIndexOf('?') < 0) {
      this.gridUrlParams = '';
    } else {
      this.gridUrlParams = this.url.substring(this.url.lastIndexOf('?'));
    }
    buildUrl += params;

    return buildUrl;
  }

  public onQuickFilterChanged($event, dt) {
    if ($event.key === 'Enter') {
      this.applySearch(this.search);
      dt.first = 0;
    }

    if ($event.key === 'Backspace' && this.search.trim() === '') {
      this.applySearch(this.search);
      dt.first = 0;
    }
  }

  updateUrl(url: string) {
    this.url = url;
    this.offset = 0;
    this.refreshList();
  }

  loadDatasourceLazy(event: LazyLoadEvent) {
    if (event.sortField !== undefined) {
      const headerName: any = this.columnDefs.filter(item => item.field === event.sortField)
      if (event.sortOrder === 1) {
        this.liveAnnouncer.announce(this.commonBindingDataService.getLabel(`aria_label_table_header_announce_sort_asc`) +
          headerName[0].header)
      } else {
        this.liveAnnouncer.announce(this.commonBindingDataService.getLabel(`aria_label_table_header_announce_sort_desc`) +
          headerName[0].header)
      }
    }
    this.sortF = this.defaultSortField;
    this.offset = event.first;
    this.setRowLength = event.rows;
    if (event.sortField !== undefined) {
      this.sortF = event.sortField;
    }
    this.sortO = event.sortOrder > 0 ? 'asc' : 'desc';
    this.fetchAndLoadData();
  }

  onRowSelect(event) {
    this.rowSelectIndex = event.index % this.paginationPageSize;
    this.displayRowView = true;
  }

  onRowUnselect(event) {
  }

  actionBtnClick(event, data: any, action: string) {
    event.stopPropagation();
    const obj = { row: data, class: action };
    this.displayRowView = false;
    this.actionBtnClickedEvent.emit(obj);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getSelectedRecords() {
    return this.selectedRecords;
  }

  applySearch(searchText: string) {
    this.searchText = searchText;
    this.offset = 0;
    this.first = 0;
    this.fetchAndLoadData();
  }

  exportGridExcel(event: any) {
    const that = this;
    this.gridService.downloadExcelGridData(that.getUrl(that.exportUrl) + this.gridUrlParams);
  }

  exportGridPdf(event: any) {
    const that = this;
    this.gridService.downloadPdfGridData(that.getUrl(that.printUrl) + this.gridUrlParams);
  }

  onFocus(data, autoComplete) {
    this.filter({ query: '' }, data);
    autoComplete.show()
  }

  filter(event, data: KeyValueModel[]) {
    this.suggestion = [];
    for (let i = 0; i < data.length; i++) {
      const documentOption = data[i];
      if (documentOption.key.toLowerCase().includes(event.query.toLowerCase())) {
        this.suggestion.push(documentOption);
      }
    }
  }

  onClear(key, rowData) {
    rowData[key] = '0';
  }

  onSelectMulti(event, key, rowData) {
    rowData[key].push(event.value);
  }

  onRemove(event, key, rowData) {
    rowData[key] = rowData[key].filter(item => item !== event.value)
  }
}
